import http from "axiosSetup";
import type {
  LatestLoadVelocityProfileParams,
  LoadVelocityProfile,
  LoadVelocityProfileLite,
  LoadVelocityProfileParams,
} from "types/load-velocity-profile";

class LoadVelocityProfileService {
  /**
   * Retrieves the predicted 1RM range of every load-velocity profile for a given athlete and exercise in a date range, optionally filtered by one or more variants.
   */
  static async getAll(athleteId: string, exerciseId: string, params: LoadVelocityProfileParams) {
    return http
      .get<LoadVelocityProfileLite[]>(`/athletes/${athleteId}/exercises/${exerciseId}/load-velocity-profiles`, {
        params,
        paramsSerializer: { indexes: null },
      })
      .then((response) => response.data);
  }

  /**
   * Retrieves the latest load-velocity profile of each requested variant for a given athlete and exercise. Variants without a profile are left out.
   */
  static async getLatest(athleteId: string, exerciseId: string, params: LatestLoadVelocityProfileParams = {}) {
    return http
      .get<LoadVelocityProfile[]>(`/athletes/${athleteId}/exercises/${exerciseId}/load-velocity-profiles/latest`, {
        params,
        paramsSerializer: { indexes: null },
      })
      .then((response) => response.data);
  }
}

export default LoadVelocityProfileService;
